import React from 'react'
import { DocsBreadcrumbBar } from './docs-breadcrumb-bar'
export const DocContainerNoMenu = ({ children, blogTitle = 'Docs' }) => (
  <>
    <DocsBreadcrumbBar title={blogTitle} />
    <section className="blog">
      <div className="container">{children}</div>
    </section>
  </>
)
